// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1otWH","range":"MonthRangeSwitch_range__sDCmR","disabled":"MonthRangeSwitch_disabled__1zBVA"};